import * as React from 'react';
import * as _ from 'lodash';

import Scenario from '../../models/Scenario';
import { SuccessCriteria } from '../../models/project/SuccessCriteria';
import StatisticsCalculator from '../../services/statistics/StatisticsCalculator';

import './Overview.css';
import ProbabilityCalculator from '../../services/statistics/ProbabilityCalculator';

class Overview extends React.Component<{
  scenarios: Scenario[],
  successCriteria?: SuccessCriteria
}, { successPercentage: number|null }> {

  public constructor(props) {
    super(props);

    if (_.isUndefined(this.props.successCriteria)) {
      this.state = {
        successPercentage: null
      };
      
    } else {
      const percentage = StatisticsCalculator.calculateLikelyProbability(props.scenarios, props.successCriteria);
      this.state = {
        successPercentage: percentage
      };
    }

  }

  public render() {
    if (!_.isNull(this.state.successPercentage) && !_.isUndefined(this.props.successCriteria)) {
      const successCategory = ProbabilityCalculator.determineSuccessCategory(this.state.successPercentage);
      const successClassName = ProbabilityCalculator.determineProbabilityClassName(successCategory);
      
      return (
        <React.Fragment>
          <div id="scenarios-overview">
            <h2>Success prediction: 
              <span className={`${successClassName} probability-category`}>{successCategory}</span> 
              </h2>
            <table>
              <tbody>
              <tr>
                  <th className="label">Success probability</th>
                  <td><span id="success-percentage">{new Intl.NumberFormat('de-DE', { 'style': 'percent', 'minimumFractionDigits': 0 }).format(this.state.successPercentage)}</span></td>
                </tr>
                <tr>
                  <th className="label">Success condition</th>
                  <td>"{this.props.successCriteria.description}"</td>
                </tr>
              </tbody>
            </table>
  
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <div id="scenarios-overview">
            <h2>Prediction: 
              <span className={`probability-undefined probability-category`}>Success condition not defined</span> 
              </h2>
          </div>
        </React.Fragment>
      )
    }

  }
}

export default Overview;


// WEBPACK FOOTER //
// ./src/components/overview/Overview.tsx